/**
 * Route: /hosts/:id — Story 2.2 Host-Management-UI
 *
 * Deep-Link auf das Host-Detail: rendert die Uebersicht mit geoeffnetem
 * Bearbeitungs-Drawer (ModalSheet) fuer den Host. Schliessen navigiert
 * zurueck zu /hosts.
 */
import { createFileRoute } from '@tanstack/react-router'
import { HostsPage } from '../features/hosts/HostsPage'

export const Route = createFileRoute('/_auth/hosts/$id')({
  component: function HostDetailRoute() {
    const { id } = Route.useParams()
    const numericId = Number(id)
    return (
      <HostsPage hostId={Number.isFinite(numericId) ? numericId : undefined} />
    )
  },
})
